// src/components/Fields/VersionNumberFieldPreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import TagIcon from '@mui/icons-material/Tag'; // pick any icon you like
import DraggablePreviewWrapper from './DraggablePreviewWrapper';
import { useFormLayout } from '../../contexts/FormLayoutContext';

const VersionNumberFieldPreview = ({ id, index }) => {
  const { showDropZones, setShowDropZones } = useFormLayout();

  // Optional debug – keep if useful
  try {
    setShowDropZones && setShowDropZones.toString();
//    console.log(
//      '[VersionNumberFieldPreview] setShowDropZones function definition:',
//      setShowDropZones.toString(),
//    );
  } catch (error) {
    console.error(
      '[VersionNumberFieldPreview] Error logging setShowDropZones function definition:',
      error,
    );
  }

  return (
    <DraggablePreviewWrapper
      id={id}
      // 🔴 Palette type (NOT the runtime render type)
      type="asset-version"
      index={index}
      isNew={true}
      showDropZones={showDropZones}
      setShowDropZones={setShowDropZones}
    >
      <Box display="flex" alignItems="center">
        <TagIcon
          sx={{
            fontSize: '0.95rem',
            marginRight: '8px',
            color: '#455A64',
          }}
        />
        <Typography
          variant="body2"
          sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}
        >
          Asset version
        </Typography>
      </Box>
    </DraggablePreviewWrapper>
  );
};

export default VersionNumberFieldPreview;